import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import './ImportCheckList.css';

function ImportCheckList() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [bookmarks, setBookmarks] = useState([]);
    const [checked, setChecked] = useState([]);
    const [toggleText, setToggleText] = useState("Clear all");
    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const toggleRef = useRef(null);
    const confirmRef = useRef(null);

    useEffect(() => {
        getBookmarksList();
    }, [id]);

    const getBookmarksList = () => {
        const path = "/api/import/pocket/retrieve";
        const params = {
            collection_uuid: id
        };

        axios.get(path, { params })
            .then((res) => {
                setBookmarks(res.data.bookmarks);
                const initialChecked = res.data.bookmarks.map((_, index) => index);
                setChecked(initialChecked);

                if (res.data.bookmarks.length === 0) {
                    setErrorMsg("No bookmarks");
                }
            })
            .catch((error) => {
                console.error(error);
                setErrorMsg("An error occurred");
            });
    };

    const submitBookmarks = () => {
        setIsLoading(true);

        const path = "/api/import/pocket/bookmarks";
        const selectedBookmarks = checked.map(index => bookmarks[index]);
        const payload = {
            collection_uuid: id,
            bookmarks: selectedBookmarks
        };

        axios.post(path, payload)
            .then((res) => {
                if (res.data.status === "success") {
                    redirectToCollection();
                } else {
                    setErrorMsg(res.data.message);
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setErrorMsg("An error occurred");
                setIsLoading(false);
            });
    };

    const toggle = () => {
        if (toggleText === "Clear all") {
            setChecked([]);
            setToggleText("Select all");
        } else {
            const allIndexes = bookmarks.map((_, index) => index);
            setChecked(allIndexes);
            setToggleText("Clear all");
        }
    };

    const toggleCheckbox = (index) => {
        const idx = checked.indexOf(index);
        if (idx > -1) {
            setChecked(checked.filter(i => i !== index));
        } else {
            setChecked([...checked, index]);
        }
    };

    const redirectToCollection = () => {
        navigate(`/bookmarks/${id}`);
    };

    return (
        <div className="container">
            <div className="bookmarksTitle">Import</div>
            <form>
                <div className="field row error">{errorMsg}</div>
                <div className="field row">
                    <div className="col-lg-4 row">
                        <Button
                            variant="outline-danger"
                            className="col"
                            onClick={redirectToCollection}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outline-info"
                            className="col"
                            onClick={toggle}
                            disabled={bookmarks.length === 0}
                            ref={toggleRef}
                        >
                            {toggleText}
                        </Button>
                        <Button
                            variant="dark"
                            className="col"
                            onClick={submitBookmarks}
                            disabled={bookmarks.length === 0 || isLoading}
                            ref={confirmRef}
                        >
                            {isLoading ? 'Loading...' : 'Confirm'}
                        </Button>
                    </div>
                </div>
                {bookmarks.map((bookmark, index) => (
                    <div
                        key={index}
                        className="field box label"
                        onClick={() => toggleCheckbox(index)}
                    >
                        <article className="media">
                            <div className="media-left">
                                <input
                                    type="checkbox"
                                    className="checkbox"
                                    checked={checked.includes(index)}
                                    onChange={() => toggleCheckbox(index)}
                                />
                            </div>
                            <div className="media-content">
                                <div className="content">
                                    <span className="label-title">{bookmark.title}</span>
                                    <span className="label-subtitle">{bookmark.url}</span>
                                </div>
                            </div>
                        </article>
                    </div>
                ))}
            </form>
        </div>
    );
}

export default ImportCheckList;
